import "core-promise/client/core-promise.js";
import "./polyfills/array_find.js";
import "./polyfills/array_includes.js";
import "./polyfills/object_values_polyfill.js";
import "./polyfills/url_search_params.js";
import "./polyfills/string_includes.js";
